// extracted by mini-css-extract-plugin
export default {"container":"board_container__Dp8jH"};